import { createAsyncThunk } from "@reduxjs/toolkit";
import type { FontsResponse } from "../../models/fonts";
import { environment } from "../../environments";
const API_BASE_URL = environment.apiUrl;

/** שליפת כל הפונטים */
export const getFonts = createAsyncThunk<
  FontsResponse,
  void,
  { rejectValue: string }
>(
  "fonts/GetFonts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Fonts/GetFonts`);

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: FontsResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to fetch fonts");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
